import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DvidshubApiService {
  constructor(private http: HttpClient) {}

  handleError(e: any): Observable<never> {
    return throwError(e.message || 'Server error');
  }

  getVideoMetadata(
    id: string,
  ): Observable<{ title: string; description: string }> {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'false');
    return this.http
      .get<{ results: { title: string; description: string } }>(
        `https://api.dvidshub.net/asset?api_key=key-5ac79b2b2e112&id=video:${id}`,
        {
          headers,
        },
      )
      .pipe(
        catchError(this.handleError.bind(this)),
        map(o => {
          if (o.results) {
            return {
              title: o.results.title,
              description: o.results.description,
            };
          } else {
            return { title: '', description: '' };
          }
        }),
      );
  }
}
